import $ from "jquery";
import { PU_TO_NU } from "../constants/NcodeConstants";
export function nprojToJson(nproj) {
    const $preset = $(nproj).find("preset");
    const pattern = $preset.find("pattern").text();
    const $bookXml = $(nproj).find("book");
    const title = $bookXml.find("title").text();
    const author = $bookXml.find("author").text();
    const section = parseInt($bookXml.find("section").text());
    const owner = parseInt($bookXml.find("owner").text());
    const book = parseInt($bookXml.find("code").text());
    // const start_page = parseInt($bookXml.find("start_page").text());
    let start_page = parseInt($bookXml.find("start_page").text());
    // const extra_info = $bookXml.find("extra_info").text(); //     <extra_info>pdf_page_count=2</extra_info>, 3.27.603, spring note
    const segment_info = $bookXml.find("segment_info");
    const ncode_start_page_str = segment_info.attr("ncode_start_page");
    if (ncode_start_page_str) {
        const start_page_new = parseInt(ncode_start_page_str);
        start_page = start_page_new;
    }
    const $pdfXml = $(nproj).find("pdf");
    const filename = $pdfXml.find("path").text();
    const $pages = $(nproj).find("pages");
    const numPages = parseInt($pages.attr("count"));
    const ret = {
        "book": {
            title, author,
            section, owner, book, start_page,
        },
        "pdf": {
            filename,
            numPages,
        },
        "pages": new Array(numPages)
    };
    const $page_items = $pages.find("page_item");
    $page_items.each((index, page) => {
        const p = $(page);
        const pageDelta = parseInt(p.attr("number"));
        const sobp = { section, owner, book, page: start_page + pageDelta };
        const surface_pu = {
            left: parseFloat(p.attr("x1")),
            top: parseFloat(p.attr("y1")),
            right: parseFloat(p.attr("x2")),
            bottom: parseFloat(p.attr("y2")),
        };
        const $crop_margin = p.attr("crop_margin");
        const margins = $crop_margin.split(",");
        const padding_pu = {
            left: parseFloat(margins[0]),
            top: parseFloat(margins[1]),
            right: parseFloat(margins[2]),
            bottom: parseFloat(margins[3]),
        };
        const size_pu = {
            width: (surface_pu.right - padding_pu.right) - (surface_pu.left + padding_pu.left),
            height: (surface_pu.bottom - padding_pu.bottom) - (surface_pu.top + padding_pu.top),
        };
        const nu = {
            Xmin: (surface_pu.left + padding_pu.left) * PU_TO_NU,
            Ymin: (surface_pu.top + padding_pu.top) * PU_TO_NU,
            Xmax: (surface_pu.left + size_pu.width) * PU_TO_NU,
            Ymax: (surface_pu.top + size_pu.height) * PU_TO_NU,
        };
        // const Xmax_physical = (surface_pu.right - padding_pu.right) * PU_TO_NU;
        // const Ymax_physical = (surface_pu.bottom - padding_pu.bottom) * PU_TO_NU;
        // 결과를 push
        const item = {
            sobp,
            padding_pu,
            size_pu, nu
        };
        ret.pages[pageDelta] = item;
    });
    return ret;
}
//# sourceMappingURL=nprojToJson.js.map